/* eslint-disable no-restricted-syntax */
import routeNames from '@/fish/router/constants'

/* SETTINGS AND ACCOUNT ROUTES */
export default [
  {
    name: routeNames.ACCOUNT_FISH,
    path: 'account/:action',
    component: () => import('@/components/account/account-card'),
  },
  {
    name: 'manage-account-fish',
    path: 'account/:action/manage',
    component: () => import('@/components/account/membership-card'),
  },
  {
    name: routeNames.SETTINGS_FISH,
    path: 'settings',
    redirect: { name: 'fish-map-settings' },
    component: () => import('@/components/settings-card/panel-settings'),
    children: [
      {
        name: 'fish-map-settings',
        path: 'map-settings',
        component: () => import('@/components/settings-card/map-settings-tab'),
      },
      {
        name: 'fish-employee-settings',
        path: 'employee-settings',
        meta: { employeeRoute: true },
        component: () =>
          import('@/components/settings-card/employee-settings-tab'),
      },
    ],
  },
  {
    name: 'change-password-fish',
    path: 'account/:action/password',
    component: () => import('@/components/change-password'),
  },
  {
    name: routeNames.APP_FEEDBACK_FISH,
    path: 'feedback',
    component: () => import('@/fish/components/feedback/feedback-card'),
  },
  {
    name: 'referral',
    path: 'referral',
    component: () => import('@/fish/components/ui/referral-card'),
  },
]
